gsap.registerPlugin(ScrollTrigger);

// ========== 全局变量 ==========
let isSubOpen = false;
let hoverExpandTween = null;
let navScrollTrigger = null;
let wheelLock = false; // 滚轮锁定标记
let desktopWrap = null;
let submenuCloseCallback = null; // 新增：子菜单关闭后导航还原回调

// 全局滚轮拦截（禁止页面滚动）
function preventWheel(e) {
    if (wheelLock) e.preventDefault();
}
window.addEventListener('wheel', preventWheel, { passive: false });

// ===================== 跑马灯 =====================
function startWarningScroll() {
    const scrollWrap = document.querySelector(".warning_scroll_wrap");
    const textBox = document.querySelector(".scroll_text");

    if (!scrollWrap || !textBox) {
        setTimeout(startWarningScroll, 300);
        return;
    }

    let originHtml = textBox.dataset.originHtml;
    if (!originHtml) {
        originHtml = textBox.innerHTML;
        textBox.dataset.originHtml = originHtml;
    }
    // 恢复原始单份内容
    textBox.innerHTML = originHtml;

    // ✅ 不直接塞3份进真实DOM，用克隆元素获取单条宽度（脱离文档流，不会撑大页面）
    const tempClone = textBox.cloneNode(true);
    tempClone.style.position = "absolute";
    tempClone.style.left = "-9999px";
    tempClone.style.visibility = "hidden";
    document.body.appendChild(tempClone);
    const singleWidth = tempClone.offsetWidth;
    document.body.removeChild(tempClone);

    // 现在再填充3份用于滚动
    textBox.innerHTML = originHtml + originHtml + originHtml;

    setTimeout(() => {
        const scrollAnim = gsap.to(textBox, {
            x: -singleWidth,
            duration: 26,
            ease: "none",
            repeat: -1,
            onRepeat: () => {
                gsap.set(textBox, { x: 0 });
            }
        });

        const onMouseEnter = () => scrollAnim.pause();
        const onMouseLeave = () => scrollAnim.resume();
        scrollWrap.addEventListener("mouseenter", onMouseEnter);
        scrollWrap.addEventListener("mouseleave", onMouseLeave);

        let resizeTimer = null;
        function handleResize() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                scrollAnim.kill();
                gsap.set(textBox, { x: 0 });
                scrollWrap.removeEventListener("mouseenter", onMouseEnter);
                scrollWrap.removeEventListener("mouseleave", onMouseLeave);
                startWarningScroll();
            }, 150);
        }
        window.addEventListener("resize", handleResize);

    }, 50);
}
startWarningScroll();

// ===================== 导航切换：到达top top直接切换，回滚复原 + 悬浮展开交互【修复终版】 =====================
document.addEventListener("DOMContentLoaded", function () {
    desktopWrap = document.querySelector(".menu .desktop_only");

    // 常态样式
    const normalState = {
        position: "relative",
        top: "auto",
        left: "auto",
        xPercent: 0,
        width: "100%",
        borderRadius: "0px",
        background: "#ffffff",
        boxShadow: "inset 0 -4px 12px rgba(0,0,0,0.12)",
        zIndex: 90,
        maskImage: "",
        WebkitMaskImage: ""
    };

    // 椭圆吸顶基础样式（滚动触发）
    const ovalState = {
        position: "fixed",
        top: 0,
        left: "50%",
        xPercent: -50,
        width: "90rem",
        borderRadius: "9999px",
        background: "rgba(240, 245, 254, 0.5)",
        backdropFilter: "blur(10px)",
        boxShadow: "inset 0 -4px 12px rgba(0,0,0,0.12)",
        zIndex: 90,
        force3D: true
    };

    // 吸顶状态【鼠标悬浮展开全屏样式】
    const ovalHoverState = {
        background: "#ffffff",
        width: "100%",
        borderRadius: "0px",
    };

    // 初始化默认常态
    gsap.set(desktopWrap, normalState);

    // 滚动触发器【移除timeline，使用onEnter/onLeaveBack回调，规避动画抢占】
    navScrollTrigger = ScrollTrigger.create({
        trigger: ".menu .desktop_only",
        start: "top top",
        end: "9999px bottom",
        invalidateOnRefresh: true,
        markers: false,
        onEnter: () => {
            submenuCloseCallback = null;
            gsap.killTweensOf(desktopWrap);
            gsap.to(desktopWrap, {
                ...ovalState,
                duration: 0.25,
                onUpdate: function () {
                    if (!isSubOpen) {
                        desktopWrap.style.maskImage = "linear-gradient(#000, #000)";
                        desktopWrap.style.webkitMaskImage = "linear-gradient(#000, #000)";
                    } else {
                        desktopWrap.style.maskImage = "";
                        desktopWrap.style.webkitMaskImage = "";
                    }
                }
            });
        },
        onLeaveBack: () => {
            submenuCloseCallback = null;
            gsap.killTweensOf(desktopWrap);
            gsap.to(desktopWrap, {
                ...normalState,
                duration: 0.25
            });
        }
    });

    // ========== 鼠标移入/移出交互逻辑【核心修复】 ==========
    desktopWrap.addEventListener("mouseenter", () => {
        if (!navScrollTrigger.isActive) return;
        gsap.killTweensOf(desktopWrap);
        hoverExpandTween = gsap.to(desktopWrap, {
            ...ovalHoverState,
            duration: 0.3,
            ease: "power2.out"
        });
        wheelLock = true;
    });

    desktopWrap.addEventListener("mouseleave", () => {
        if (!navScrollTrigger.isActive) return;
        wheelLock = false;
        gsap.killTweensOf(desktopWrap);

        // 如果子菜单正在打开，注册回调，等子菜单关闭自动还原导航
        if (isSubOpen) {
            submenuCloseCallback = () => {
                gsap.to(desktopWrap, {
                    ...ovalState,
                    duration: 0.3,
                    ease: "power2.out"
                });
                submenuCloseCallback = null;
            };
            return;
        }
        // 无子菜单，直接恢复椭圆
        hoverExpandTween = gsap.to(desktopWrap, {
            ...ovalState,
            duration: 0.3,
            ease: "power2.out"
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll('.nav a');
    const allSubmenu = document.querySelectorAll('.main_Submenu');


    function setNavActiveByMarker(){
        const markerEl = document.querySelector('.body');
        if(!markerEl){
            return;
        }

        const classList = Array.from(markerEl.classList);

        const currentPageClass = classList.find(cls => cls.startsWith('page-'));
        if(!currentPageClass){
            return;
        }

        const currentPage = currentPageClass.replace('page-','');

        const navLinks = document.querySelectorAll('.menu .desktop_only .nav a');

        navLinks.forEach(link => link.classList.remove('active'));

        navLinks.forEach(link => {
            const linkPage = link.dataset.page;
            if(linkPage === currentPage){
                link.classList.add('active');
            }
        });
    }

    // 页面加载完直接执行，不要再嵌套DOMContentLoaded
    setNavActiveByMarker();


    const navWrap = document.querySelector('.menu .desktop_only .nav');
    const navLinkList = navWrap.querySelectorAll('a');
    navLinkList.forEach(link=>{
      link.addEventListener('mouseenter',function(){
        navLinkList.forEach(a=>a.classList.remove('active'));
        this.classList.add('active');
      })
    })
    // ✅修复：调用真实存在的函数 setNavActiveByMarker
    navWrap.addEventListener('mouseleave',function(){
        setNavActiveByMarker();
    })


    const animDuration = 0.3;
    const delayClose = 300;
    let closeTimer = null;
    let activeSub = null;


    function closeActiveSubmenu() {
        if (!activeSub) return;
        activeSub.classList.remove("open-animate");
        gsap.to(activeSub, {
            maxHeight: 0,
            duration: animDuration,
            onComplete: () => {
                activeSub = null;
                isSubOpen = false;
                wheelLock = false;
                if (typeof submenuCloseCallback === "function") {
                    submenuCloseCallback();
                }
            }
        });
    }


    function openSubmenu(subEl) {
        isSubOpen = true;
        wheelLock = true;
        desktopWrap.style.maskImage = "";
        desktopWrap.style.webkitMaskImage = "";

        if (activeSub && activeSub !== subEl) {
            gsap.killTweensOf(activeSub);
            activeSub.classList.remove("open-animate");
            gsap.to(activeSub, { maxHeight: 0, duration: animDuration });
        }
        activeSub = subEl;
        gsap.killTweensOf(subEl);

        gsap.set(subEl, { maxHeight: "100vh" });
        subEl.classList.add("open-animate");

        const innerWrap = subEl.querySelector(".bodymenu2");
        if (!innerWrap) {
            setTimeout(() => {
                const wrap = subEl.querySelector(".bodymenu2");
                const h = wrap ? wrap.offsetHeight : 320;
                gsap.to(subEl, { maxHeight: h, duration: animDuration, ease: "power2.out" });
            }, 160);
        } else {
            gsap.to(subEl, {
                maxHeight: innerWrap.offsetHeight,
                duration: animDuration,
                ease: "power2.out"
            });
        }
    }


    navLinks.forEach((link, index) => {
        link.addEventListener('mouseenter', () => {
            clearTimeout(closeTimer);
            if (index === 5) return;
            const targetSub = document.querySelector(`.main_Submenu${index}`);
            if (targetSub) openSubmenu(targetSub);
        });
        link.addEventListener('mouseleave', () => {
            clearTimeout(closeTimer);
            if (index === 5) return;
            const targetSub = document.querySelector(`.main_Submenu${index}`);
            if (!targetSub) return;
            closeTimer = setTimeout(() => {
                if (!targetSub.matches(':hover')) {
                    closeActiveSubmenu();
                }
            }, delayClose);
        });
    });


    allSubmenu.forEach(sub => {
        sub.addEventListener('mouseenter', () => {
            clearTimeout(closeTimer);
            openSubmenu(sub);
        });
        sub.addEventListener('mouseleave', () => {
            clearTimeout(closeTimer);
            closeTimer = setTimeout(() => {
                closeActiveSubmenu();
            }, delayClose);
        });
    });
});


// ===================== main_Submenu1 数据驱动渲染 & Swiper初始化 =====================
document.addEventListener("DOMContentLoaded", function () {
    // ========= 全局标记：控制只渲染一次 =========
    let submenuRendered = false;
    function rem2px(remVal){
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        return remVal * rootFontSize;
    }
    // 【配置区，所有产品信息集中维护】
    // 新增 groupLabel 分组标识
    const SUBMENU1_DATA = [
        {
            groupLabel: "DISPOSABLE",
            targetId: "box1",
            title: "BLADE SERIES",
            productList: [
                {
                    title: "BLADE",
                    subTitle: "MAX",
                    puffInfo: "90K PUFFS",
                    link: THEME_MENUS.BLADE_MAX,
                    isNew: true,
                    tasteColors: ['#734bf4', '#2ba5ff', '#32ff1e', '#ffe658'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/blade-max-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/blade-max-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/blade-max-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/blade-max-4.png",

                    ]
                },
                {
                    title: "BLADE",
                    subTitle: "30000",
                    puffInfo: "30K PUFFS",
                    link: THEME_MENUS.blade_30000,
                    isNew: false,
                    tasteColors: ['#d64c50', '#0e8fd5', '#30fd4c', '#d1d107', '#49fbfd', '#f1373a', '#fc42fc', '#e6e600', '#24ff40', '#ff9d06'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-5.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-6.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-7.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-8.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-9.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/BLADE-10.png",

                    ]
                }
            ]
        },
        {
            groupLabel: "DISPOSABLE",
            targetId: "box2",
            title: "PANDA SERIES",
            productList: [
                {
                    title: "PANDA",
                    subTitle: "POD",
                    puffInfo: "30K PUFFS",
                    link: THEME_MENUS.PANDA_POD,
                    isNew: true,
                    tasteColors: ['#fa62d1', '#fb982d', '#e8f400'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/PANDA_POD-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/PANDA_POD-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/PANDA_POD-3.png",   

                    ]
                },
                {
                    title: "PANDA",
                    subTitle: "TWINS",
                    puffInfo: "40K PUFFS",
                    link: THEME_MENUS.panda_twins,
                    isNew: false,
                    tasteColors: ['#feb6e5', '#a4a4a4', '#c7aa8d', '#b4ffe2', '#f6ffcf'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-Twins-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-Twins-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-Twins-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-Twins-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-Twins-5.png",

                    ]
                },
                {
                    title: "PANDA",
                    subTitle: "X",
                    puffInfo: "40K PUFFS",
                    link: THEME_MENUS.PANDA_X,
                    isNew: false,
                    tasteColors: ['#9c6247', '#ff779d', '#888888', '#83ee41', '#42dbff', '#926fff'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-X-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-X-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-X-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-X-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-X-5.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Panda-X-6.png",

                    ]
                },
                {
                    title: "MK",
                    subTitle: "20000",
                    puffInfo: "20K PUFFS",
                    link: THEME_MENUS.MK_20000,
                    isNew: false,
                    tasteColors: ['#3158d0', '#38de2e', '#8e32ff', '#d829c0', '#c52d39'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MK20000-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MK20000-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MK20000-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MK20000-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MK20000-5.png",

                    ]
                }
            ]
        },
        {
            groupLabel: "DISPOSABLE",
            targetId: "box3",
            title: "MECHA SERIES",
            productList: [
                {
                    title: "MECHA",
                    subTitle: "TWIST",
                    puffInfo: "75K PUFFS",
                    link: THEME_MENUS.Mecha_Twist,
                    isNew: false,
                    tasteColors: ['#d84a25', '#46a9a7', '#5a56d2', '#4772cd'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Mecha-Twist-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Mecha-Twist-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Mecha-Twist-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/Mecha-Twist-4.png",

                    ]
                },
                {
                    title: "MECHA",
                    subTitle: "X",
                    puffInfo: "36K PUFFS",
                    link: THEME_MENUS.MECHA_X,
                    isNew: false,
                    tasteColors: ['#fff884', '#ffd0ff', '#a9dcff', '#e4e4e4', '#77ffc1'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-X-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-X-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-X-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-X-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-X-5.png",

                    ]
                },
                {
                    title: "M-MECHA",
                    subTitle: "",
                    puffInfo: "16K PUFFS",
                    link: THEME_MENUS.M_Mecha_16000,
                    isNew: false,
                    tasteColors: ['#373737', '#6af3cb', '#fafafa', '#c9c3ff', '#ffe979', '#76cbf2', '#ffa688', '#b8d775', '#ffc2df'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-5.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-6.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-7.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-8.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/M-MECHA-9.png",

                    ]
                },
                {
                    title: "MECHA",
                    subTitle: "PRO",
                    puffInfo: "35K PUFFS",
                    link: THEME_MENUS.Mecha_Pro_Edge_Edition,
                    isNew: false,
                    tasteColors: ['#11ffee', '#ff4ac8', '#00fc25', '#ffa947'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-PRO-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-PRO-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-PRO-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MECHA-PRO-4.png",

                    ]
                }
            ]
        },
        {
            groupLabel: "DISPOSABLE",
            targetId: "box4",
            title: "KITTY SERIES",
            productList: [
                {
                    title: "KITTY",
                    subTitle: "S",
                    puffInfo: "40K PUFFS",
                    link: THEME_MENUS.KITTY_S,
                    isNew: false,
                    tasteColors: ['#bdb1ff', '#ddf786', '#bafcdd', '#ffcec1'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-S-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-S-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-S-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-S-4.png",

                    ]
                },
                {
                    title: "KITTY",
                    subTitle: "",
                    puffInfo: "30K PUFFS",
                    link: THEME_MENUS.KITTY,
                    isNew: false,
                    tasteColors: ['#a2e8ff', '#ecffd0', '#e5d9ff', '#fecee5', '#ffffc1'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/KITTY-5.png",

                    ]
                }
            ]
        },
        {
            groupLabel: "DISPOSABLE",
            targetId: "box5",
            title: "WIFLUX SERIES",
            productList: [
                {
                    title: "WIFLUX",
                    subTitle: "",
                    puffInfo: "24K PUFFS",
                    link: THEME_MENUS.WIFLUX_24000,
                    isNew: false,
                    tasteColors: ['#3f71ff', '#fc5200', '#c6ff00', '#fcaa00', '#f046ff', '#ff428a', '#38fcff', '#40c4ff'],
                    images: [
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-1.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-2.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-3.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-4.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-5.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-6.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-7.png",
                       "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/WIFLUX-8.png",

                    ]
                }
            ]
        },
        {
            groupLabel: "NICOTINE SALT", // 大分组标题
            targetId: "box6",
            title: "SALT SERIES",
            productList: [
                {
                    title: "MERRYMI",
                    subTitle: "SALT",
                    puffInfo: "",
                    link: THEME_MENUS.MERRYMI_E_LIQUID,
                    isNew: true,
                    tasteColors: ['#5f4094', '#3b67b0', '#90d6f9', '#cf2c29', '#494c98'],
                    images: [
                        "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MERRYMI-SALT-1.png",
                        "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MERRYMI-SALT-2.png",
                        "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MERRYMI-SALT-3.png",
                        "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MERRYMI-SALT-4.png",
                        "https://cdn.shopify.com/s/files/1/0619/6494/3433/files/MERRYMI-SALT-5.png",
                    ]
                }
            ]
        }
    ];
    // Swiper全局参数
    const SWIPER_CONFIG = {
        product: {
            slidesPerView: 4,
            spaceBetween: rem2px(3.5),
            loop: false,
            allowTouchMove: true,
            width: undefined,
            resizeObserver: true,
            grabCursor:true,
            
        },
        taste: {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 1000,
                disableOnInteraction: false
            }
        }
    };
    const tabContainer = document.getElementById("tabContainer");
    const boxContainer = document.getElementById("boxContainer");
    const swiperCache = {};

    // 渲染左侧Tab标题【改造：输出分组标题 + 系列】
    function renderTabs() {
        let lastGroup = null;
        SUBMENU1_DATA.forEach((item, index) => {
            // 如果当前分组和上一个不一样，输出分组标题
            if(lastGroup !== item.groupLabel){
                const groupDiv = document.createElement("div");
                groupDiv.className = `bodymenu2_group_title`;
                groupDiv.innerText = item.groupLabel;
                tabContainer.appendChild(groupDiv);
                lastGroup = item.groupLabel;
            }
            // 渲染可点击的系列tab
            const div = document.createElement("div");
            div.className = `bodymenu2_title ${index === 0 ? "ON" : ""}`;
            div.dataset.target = item.targetId;
            div.innerText = item.title;
            tabContainer.appendChild(div);
        });
    }

    // 渲染右侧bodymenu2_box
    function renderBoxes() {
        SUBMENU1_DATA.forEach((series, index) => {
            const boxWrap = document.createElement("div");
            boxWrap.className = `bodymenu2_box ${index === 0 ? "ON" : ""}`;
            boxWrap.dataset.id = series.targetId;
            let productHtml = "";
            series.productList.forEach(product => {
                const colorData = JSON.stringify(product.tasteColors);
                productHtml += `
                <div class="swiper-slide">
                    <div class="bodymenu2_product">
                        ${product.isNew ? '<span class="tag-new">NEW</span>' : ''}
                        <div class="bodymenu2_taste_swiper swiper">
                            <div class="swiper-wrapper bodymenu2_taste_swiper_s">
                                ${product.images.map(img => `<div class="swiper-slide"><img src="${img}" loading="lazy"></div>`).join('')}
                            </div>
                            <div class="taste_pagination" data-colors='${colorData}'></div>
                        </div>
                        <div class="product-name">
                            <span class="pro-title">${product.title ?? ''}</span>
                            <span class="pro-subtitle">${product.subTitle ?? ''}</span>
                        </div>
                        <div class="product-info">${product.puffInfo}</div>
                        <a href="${product.link}" class="product-link">
                          <i class="iconfont icon-youjiantou3 icon-default"></i>
                          <i class="iconfont icon-youjiantou2 icon-hover"></i></i>
                        </a>
                    </div>
                </div>
                `;
            });
            boxWrap.innerHTML = `
                <div class="bodymenu2_boxin">
                    <div class="product_swiper swiper">
                        <div class="swiper-wrapper product_swipers">
                            ${productHtml}
                        </div>
                    </div>
                    <button class="swiper_prev product_prev">
                        <i class="iconfont icon-zuojiantou2"></i>
                    </button>
                    <button class="swiper_next product_next">
                        <i class="iconfont icon-youjiantou3"></i>
                    </button>
                </div>
            `;
            boxContainer.appendChild(boxWrap);
        });
    }

    // Tab悬浮切换事件（hover触发，不再click）
// Tab悬浮切换事件（hover触发，不再click）
    function bindTabEvent() {
        const titles = document.querySelectorAll(".bodymenu2_title");
        const groupTitles = document.querySelectorAll(".bodymenu2_group_title");

        // 公共方法：根据当前激活title，设置对应分组标题ON
        function setActiveGroupByTitle(activeTitleEl) {
            // 清除全部分组ON
            groupTitles.forEach(g => g.classList.remove("ON"));
            let prevEl = activeTitleEl.previousElementSibling;
            while (prevEl) {
                if (prevEl.classList.contains("bodymenu2_group_title")) {
                    prevEl.classList.add("ON");
                    break;
                }
                prevEl = prevEl.previousElementSibling;
            }
        }

        titles.forEach(title => {
            title.addEventListener("mouseenter", function () {
                const targetId = this.dataset.target;
                const boxes = document.querySelectorAll(".bodymenu2_box");

                // 清除所有title ON
                titles.forEach(t => t.classList.remove("ON"));
                // 清除所有box ON
                boxes.forEach(box => box.classList.remove("ON"));

                this.classList.add("ON");
                // 设置分组高亮
                setActiveGroupByTitle(this);

                const targetBox = document.querySelector(`.bodymenu2_box[data-id="${targetId}"]`);
                if (!targetBox) return;
                targetBox.classList.add("ON");
                initBoxSwiper(targetBox);
                setTimeout(() => {
                    const cache = swiperCache[targetBox.dataset.id];
                    if (cache?.productSwiper) {
                        cache.productSwiper.update();
                    }
                }, 80);
            });
        });

        // ========= 初始化：找到初始带ON的title，同步点亮分组标题 =========
        const initActiveTitle = document.querySelector(".bodymenu2_title.ON");
        if(initActiveTitle){
            setActiveGroupByTitle(initActiveTitle);
        }
    }


    // 初始化box内所有swiper
    function initBoxSwiper(boxEl) {
        const key = boxEl.dataset.id;
        if (swiperCache[key]) return;
        const productSwiper = new Swiper(boxEl.querySelector(".product_swiper"), {
            ...SWIPER_CONFIG.product,
            navigation: {
                prevEl: boxEl.querySelector(".product_prev"),
                nextEl: boxEl.querySelector(".product_next")
            }
        });
        boxEl.querySelectorAll(".bodymenu2_taste_swiper").forEach(wrap => {
            const paginationEl = wrap.querySelector(".taste_pagination");
            let colorArr = [];
            try {
                const raw = paginationEl.dataset.colors;
                colorArr = JSON.parse(raw);
            } catch (err) {
                colorArr = ['#dddddd'];
            }
            new Swiper(wrap, {
                ...SWIPER_CONFIG.taste,
                pagination: {
                    el: paginationEl,
                    clickable: true,
                    renderBullet(index, className) {
                        const color = colorArr[index] ?? '#ddd';
                        return `<span class="${className}" style="background:${color}"></span>`;
                    }
                }
            });
        });
        swiperCache[key] = { productSwiper };
    }

    // 监听子菜单展开，首次hover渲染盒子
    function watchSubmenuOpen() {
        const subMenu1 = document.querySelector(".main_Submenu1");
        let initLock = false;
        const observer = new MutationObserver(() => {
            if (initLock || submenuRendered) return;
            if (subMenu1.style.maxHeight && subMenu1.style.maxHeight !== "0px") {
                initLock = true;
                submenuRendered = true;
                renderBoxes();
                setTimeout(() => {
                    const activeBox = subMenu1.querySelector(".bodymenu2_box.ON");
                    if (activeBox) {
                        activeBox.getBoundingClientRect();
                        initBoxSwiper(activeBox);
                        setTimeout(() => {
                            activeBox.querySelectorAll('.swiper').forEach(wrap => {
                                if (wrap.swiper) {
                                    wrap.swiper.update();
                                }
                            })
                        }, 60)
                    }
                }, 150);
                setTimeout(() => initLock = false, 1000);
            }
        });
        observer.observe(subMenu1, { attributes: true, attributeFilter: ["style"] });
    }

    renderTabs();
    bindTabEvent();
    watchSubmenuOpen();
});


// 移动端菜单栏切换
let flag = false;
const main_mleft = document.querySelector(".mobile_only .mo_main .mo_main_mleft");
const main_Submenu = document.querySelector('.mobile_only .mo_main .mo_main_Submenu');

// 汉堡开关
if (main_mleft) {
  main_mleft.addEventListener('click', function () {
    var mleft_line = document.querySelector('.mobile_only .mo_main .mo_mleft_line');
    if (!flag) {
      if (mleft_line) mleft_line.style.background = "transparent";
      this.classList.add("mo_mleft_active");
      if (main_Submenu) main_Submenu.style.height = "88vh";
      flag = true;
    } else {
      closeAllMobileMenu();
    }
  });
}

// 封装：关闭整个移动端菜单，同时把所有折叠面板全部收回
function closeAllMobileMenu(){
  var mleft_line = document.querySelector('.mobile_only .mo_main .mo_mleft_line');
  if(mleft_line) mleft_line.style.background = "black";
  main_mleft.classList.remove("mo_mleft_active");
  if (main_Submenu) main_Submenu.style.height = "0";
  flag = false;

  // 把所有展开的子折叠全部重置
  document.querySelectorAll('.mo_Submenu_link').forEach(link=>{
    link.style.maxHeight = '0px';
  })
  document.querySelectorAll('.mo_Submenu_right').forEach(el=>{
    el.classList.remove('mo_Submenu_active');
  })
}

// 递归更新父级max‑height
function updateParentLinkHeight(el) {
  let parent = el.parentElement;
  while(parent){
    if(parent.classList.contains('mo_Submenu_link')){
       parent.style.maxHeight = parent.scrollHeight + 'px';
    }
    parent = parent.parentElement;
  }
}

// 折叠面板点击，只绑定div.mo_Submenu，过滤a标签
document.querySelectorAll('.mobile_only div.mo_Submenu').forEach(function (Submenu) {
  Submenu.addEventListener('click', function () {
    const Submenu_link = Submenu.nextElementSibling;
    let targetLink = Submenu_link;
    while (targetLink && !targetLink.classList.contains('mo_Submenu_link')) {
      targetLink = targetLink.nextElementSibling;
    }
    if (!targetLink) return;

    const currentMaxH = parseInt(window.getComputedStyle(targetLink).maxHeight,10);
    if(currentMaxH === 0 || isNaN(currentMaxH)){
      const mnavRight = Submenu.querySelector('.mo_Submenu_right');
      if (mnavRight) mnavRight.classList.add('mo_Submenu_active');
      targetLink.style.maxHeight = targetLink.scrollHeight + 'px';
      updateParentLinkHeight(targetLink);
    }else{
      const mnavRight = Submenu.querySelector('.mo_Submenu_right');
      if (mnavRight) mnavRight.classList.remove('mo_Submenu_active');
      targetLink.style.maxHeight = '0px';
      updateParentLinkHeight(targetLink);
    }
  });
});

// =========新增：菜单内部所有a标签点击，关闭整个移动端菜单=========
document.querySelectorAll('.mobile_only .mo_Submenu_item a').forEach(aEl=>{
  aEl.addEventListener('click',function(){
    // 加微小延迟，保证页面跳转/锚点滚动先执行，再收菜单
    setTimeout(()=>{
      closeAllMobileMenu();
    },10);
  })
})


